(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-featured-blog-posts')) {
    class SaFeaturedBlogPosts extends HTMLElement {
      constructor() {
        super();
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleSearchKeydown = this.handleSearchKeydown.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.getAttribute('data-section-id');
        this.refreshBtn = this.querySelector('.js-refresh-all-btn');
        this.searchInput = this.querySelector('.js-search-input');
        this.searchBtn = this.querySelector('.js-search-btn');
        
        if (this.refreshBtn) {
          this.refreshBtn.addEventListener('click', this.handleRefresh);
        }
        
        if (this.searchInput) {
          this.searchInput.addEventListener('keydown', this.handleSearchKeydown);
          this.searchInput.addEventListener('input', this.handleSearchInput);
        }
        if (this.searchBtn) {
          this.searchBtn.addEventListener('click', this.handleSearchClick);
        }
      }

      disconnectedCallback() {
        if (this.refreshBtn) {
          this.refreshBtn.removeEventListener('click', this.handleRefresh);
        }
        if (this.searchInput) {
          this.searchInput.removeEventListener('keydown', this.handleSearchKeydown);
          this.searchInput.removeEventListener('input', this.handleSearchInput);
        }
        if (this.searchBtn) {
          this.searchBtn.removeEventListener('click', this.handleSearchClick);
        }
      }

      performSearch(term) {
        const value = (term || '').toLowerCase().trim();
        const items = this.querySelectorAll('.resource-list__item');
        items.forEach(item => {
          const titleEl = item.querySelector('.sa-featured-blog-posts-card__title');
          if (titleEl) {
            const title = titleEl.textContent.toLowerCase();
            item.style.display = title.includes(value) ? '' : 'none';
          }
        });
      }

      handleSearchKeydown(e) {
        if (e.key === 'Enter') {
          this.performSearch(this.searchInput ? this.searchInput.value : '');
        }
      }

      handleSearchClick() {
        this.performSearch(this.searchInput ? this.searchInput.value : '');
      }

      handleSearchInput(e) {
        const val = (e.target.value || '').trim();
        if (val === '') {
          this.performSearch('');
        }
      }

      async handleRefresh(e) {
        e.preventDefault();
        if (!this.sectionId) {
          window.location.reload();
          return;
        }

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.sectionId);
          const res = await fetch(url.toString(), { credentials: 'same-origin' });
          const html = await res.text();
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const newRoot = temp.querySelector('sa-featured-blog-posts');
          if (newRoot) {
            this.innerHTML = newRoot.innerHTML;

            // Re-bind elements
            this.refreshBtn = this.querySelector('.js-refresh-all-btn');
            this.searchInput = this.querySelector('.js-search-input');
            this.searchBtn = this.querySelector('.js-search-btn');

            if (this.refreshBtn) {
              this.refreshBtn.addEventListener('click', this.handleRefresh);
            }
            if (this.searchInput) {
              this.searchInput.addEventListener('keydown', this.handleSearchKeydown);
              this.searchInput.addEventListener('input', this.handleSearchInput);
            }
            if (this.searchBtn) {
              this.searchBtn.addEventListener('click', this.handleSearchClick);
            }
          } else {
            window.location.reload();
          }
        } catch (_) {
          window.location.reload();
        }
      }
    }

    customElements.define('sa-featured-blog-posts', SaFeaturedBlogPosts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-customer-stories-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-customer-stories-showcase')) {
    customElements.define(
      'sa-customer-stories-showcase',
      class SACustomerStoriesShowcase extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.filters = Array.from(this.querySelectorAll('[data-filter]'));
          this.stories = Array.from(this.querySelectorAll('[data-story]'));
          this.emptyState = this.querySelector('[data-empty]');
          this.activeKey = this.filters.find((filter) => filter.getAttribute('aria-pressed') === 'true')?.dataset.filter || 'all';

          this.filters.forEach((filter) => {
            filter.addEventListener('click', () => this.selectFilter(filter), {
              signal: this.abortController.signal,
            });
          });

          this.updateStories();
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        selectFilter(selectedFilter) {
          this.activeKey = selectedFilter.dataset.filter || 'all';

          this.filters.forEach((filter) => {
            const isActive = filter === selectedFilter;
            filter.classList.toggle('is-active', isActive);
            filter.setAttribute('aria-pressed', String(isActive));
          });

          this.updateStories();
        }

        updateStories() {
          let visibleCount = 0;

          this.stories.forEach((story) => {
            const storyKeys = (story.dataset.tabKeys || '')
              .split(',')
              .map((key) => key.trim())
              .filter(Boolean);
            const belongsToAll = story.dataset.all === 'true';
            const isVisible = this.activeKey === 'all' ? belongsToAll : storyKeys.includes(this.activeKey);

            story.hidden = !isVisible;
            if (isVisible) visibleCount += 1;
          });

          if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
